var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
var GoogleMap = /** @class */ (function (_super) {
    __extends(GoogleMap, _super);
    function GoogleMap() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // see all available options => https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
        _this.defaultMapOptions = {
            streetViewControl: false
        };
        _this.mergedMapOptions = {};
        _this.loaded = false;
        return _this;
    }
    Object.defineProperty(GoogleMap.prototype, "map", {
        get: function () {
            return this.$refs.mapRef.$mapObject;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GoogleMap.prototype, "marker", {
        get: function () {
            return this.$refs.marker.$markerObject;
        },
        enumerable: false,
        configurable: true
    });
    GoogleMap.prototype.geocode = function (position) {
        var _a;
        (_a = this.geocoder) === null || _a === void 0 ? void 0 : _a.geocode({
            location: position,
            region: 'TH'
        }, this.geocoded); // somehow async await is not allowed
    };
    GoogleMap.prototype.geocoded = function (results, status) {
        if (status === 'OK') {
            this.fireGeocodeEvent(results[0].address_components);
        }
    };
    GoogleMap.prototype.fireGeocodeEvent = function (address) {
        return address;
    };
    GoogleMap.prototype.getPositionFromString = function (input) {
        var pattern = /(\d*\.?\d*)\s*,\s*(\d*\.?\d*)/;
        var groups = input === null || input === void 0 ? void 0 : input.match(pattern);
        if (groups) {
            return new google.maps.LatLng(Number(groups[1]), Number(groups[2]));
        }
    };
    GoogleMap.prototype.handleAutocomplete = function () {
        var _a, _b;
        var place = (_a = this.autocomplete) === null || _a === void 0 ? void 0 : _a.getPlace();
        if ((_b = place === null || place === void 0 ? void 0 : place.geometry) === null || _b === void 0 ? void 0 : _b.viewport) {
            this.updateMarker(place.geometry.location);
            return place.address_components;
        }
        else {
            var position = this.getPositionFromString(place === null || place === void 0 ? void 0 : place.name);
            if ((position === null || position === void 0 ? void 0 : position.lat()) && position.lng()) {
                this.updateMarker(position);
                this.geocode(position);
            }
        }
    };
    GoogleMap.prototype.pinPositionChanged = function (position) {
        return {
            lat: position.lat(),
            lng: position.lng()
        };
    };
    GoogleMap.prototype.updateMarker = function (position) {
        var _a;
        (_a = this.marker) === null || _a === void 0 ? void 0 : _a.setPosition(position);
        this.map.panTo(position);
        this.pinPositionChanged(position);
    };
    GoogleMap.prototype.handleClick = function (event) {
        this.updateMarker(event.latLng);
        this.geocode(event.latLng);
    };
    GoogleMap.prototype.beforeMount = function () {
        this.mergedMapOptions = __assign(__assign({}, this.defaultMapOptions), this.mapOptions);
    };
    GoogleMap.prototype.mounted = function () {
        return __awaiter(this, void 0, Promise, function () {
            var options;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$refs.mapRef.$mapPromise];
                    case 1:
                        _a.sent();
                        if (this.enableAutocomplete) {
                            options = {
                                fields: ['address_components', 'geometry', 'name']
                            };
                            this.autocomplete = new google.maps.places.Autocomplete(this.$refs.mapsearch, options);
                            this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.$refs.mapsearch);
                            this.autocomplete.addListener('place_changed', this.handleAutocomplete);
                        }
                        if (this.enableClickToPin) {
                            this.geocoder = new google.maps.Geocoder();
                            this.map.addListener('click', this.handleClick);
                        }
                        this.map.addListener('tilesloaded', function () {
                            _this.loaded = true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Prop({
            required: true,
            type: Object
        })
    ], GoogleMap.prototype, "position", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 15
        })
    ], GoogleMap.prototype, "zoom", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], GoogleMap.prototype, "enableMarker", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], GoogleMap.prototype, "enableAutocomplete", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: false
        })
    ], GoogleMap.prototype, "enableClickToPin", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () {
                return {};
            }
        })
    ], GoogleMap.prototype, "mapOptions", void 0);
    __decorate([
        Emit('geocoded')
    ], GoogleMap.prototype, "fireGeocodeEvent", null);
    __decorate([
        Emit('geocoded')
    ], GoogleMap.prototype, "handleAutocomplete", null);
    __decorate([
        Emit('pinpositionchanged')
    ], GoogleMap.prototype, "pinPositionChanged", null);
    GoogleMap = __decorate([
        Component
    ], GoogleMap);
    return GoogleMap;
}(Vue));
export default GoogleMap;
